import { AbstractControl, ValidationErrors } from '@angular/forms';

export const officeIdValidator = (control: AbstractControl): ValidationErrors | null => {
  let code;
  const codeValue = control.value;
  const codeArray = [];
  if (codeValue && codeValue !== null) {
    codeArray.push(codeValue);
    for (const val of codeArray[0]) {
      code = val.length;
    }
  }
  if (!code) {
    return null;
  }
  if (code < 9 || code > 9) {
    return {
      officeIdValidator: {
        requiredValue: 9
      }
    };
  }
  return null;
};
